export default __webpack_public_path__ + "1bb214b5b42a7d8c89e960742fa6c50a.webp";